/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type InvoiceExtraStatus =
  (typeof InvoiceExtraStatus)[keyof typeof InvoiceExtraStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceExtraStatus = {
  Suggested: 0,
  Confirmed: 1,
  Removed: 2,
} as const;
